export default __webpack_public_path__ + "static/media/ap-temples-logo.556d4f9f.svg";